import { useEffect } from 'react';
import { useAiCoachAssistantStore } from 'store/aiCoachAssistantStore';
import { Fab } from './Fab';
import { AssistantModal } from './AssistantModal';
import { AssistantWidget } from './AssistantWidget';

export const AiCoachAssistant = () => {
  const cleanupStream = useAiCoachAssistantStore((s) => s.cleanupStream);

  useEffect(() => {
    return () => {
      cleanupStream();
    };
  }, [cleanupStream]);

  return (
    <>
      <Fab />
      <AssistantModal />
      <AssistantWidget />
    </>
  );
};
